/* Cherry Ave native cart add-ons — category best sellers + relevant recommendations. */
(() => {
  'use strict';
  if (window.caCartAddonsLoaded) return;
  window.caCartAddonsLoaded = true;
  const categories = [
    {handle:'lubes',label:'Lubes'},
    {handle:'toy-cleaners',label:'Toy Cleaners'},
    {handle:'sexual-care',label:'Sexual Care'}
  ];
  const rootURL = window.Shopify?.routes?.root || '/';
  const poolCache = new Map();
  const recommendationCache = new Map();
  let mutationPending = false;
  let generation = 0;
  let lastAnnouncement = '';
  const money = (cents,currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA',{style:'currency',currency:currency || 'CAD',currencyDisplay:'narrowSymbol'}).format(cents/100);
  const route = path => rootURL + path;
  async function read(url,asText=false) {
    const controller = new AbortController();
    const timer = setTimeout(()=>controller.abort(),8000);
    try {
      const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
      if (!response.ok) throw new Error('Unavailable');
      return asText ? await response.text() : await response.json();
    } finally {clearTimeout(timer);}
  }
  async function getPool(category,currency,country) {
    const key=category.handle+':'+currency+':'+country;
    if (!poolCache.has(key)) {
      poolCache.set(key,(async()=>{
        const html=await read(route('collections/'+category.handle+'?sort_by=best-selling&section_id=ca-cart-addon-data'),true);
        const node=new DOMParser().parseFromString(html,'text/html').querySelector('[data-ca-addon-pool]');
        if (!node) throw new Error('No product data');
        const data=JSON.parse(node.textContent);
        if(data.category!==category.handle || !Array.isArray(data.products)) throw new Error('Invalid category');
        return data.products.map((product,rank)=>({...product,rank,category:category.handle,label:category.label}));
      })().catch(error=>{poolCache.delete(key);throw error;}));
    }
    return poolCache.get(key);
  }
  async function getRelated(state) {
    const ids=[...new Set(state.items.map(item=>item.id))].slice(0,2);
    const lists=await Promise.all(ids.map(id=>{
      const key=id+':'+state.currency+':'+state.country;
      if(!recommendationCache.has(key)) recommendationCache.set(key,read(route('recommendations/products.json?product_id='+id+'&limit=10&intent=related')).then(data=>data.products || []).catch(()=>[]));
      return recommendationCache.get(key);
    }));
    return new Set(lists.flat().map(product=>product.id));
  }
  function chooseProducts(pools,state,related) {
    const inCart=new Set(state.items.map(item=>item.id));
    const cleanerIds=new Set((pools[1] || []).map(product=>product.id));
    const lubeIds=new Set((pools[0] || []).map(product=>product.id));
    const selected=new Set();
    const isCAD=state.currency==='CAD';
    const gap=isCAD ? Math.max(0,state.threshold-state.eligibleSubtotal) : 0;
    return pools.map((pool,index)=>{
      const candidates=pool.filter(product=>{
        if(!product.available || !product.stockAvailable || product.giftCard || !product.requiresShipping || product.price<=0 || inCart.has(product.id) || selected.has(product.id)) return false;
        if(state.excludedTag && product.tags.includes(state.excludedTag)) return false;
        if(isCAD && product.price>3500) return false;
        if(index===2 && (cleanerIds.has(product.id) || lubeIds.has(product.id))) return false;
        const text=(product.title+' '+product.tags.join(' ')).toLowerCase();
        // Keep ingestible supplements and products needing individualized selection out of quick add-ons.
        if(/capsules?|supplement|performance pills?|numbing|desensiti/.test(text)) return false;
        // Restrict the default lube slot to plain water-based options; avoid implying silicone/hybrid compatibility.
        if(index===0 && (!/water[ -]?based|h2o|sassy|organics natural (lube|gel)/.test(text) || /silicone|hybrid|silk|oil|warming|sizzle|sensations|cannabis|flavou?r|strawberry|chocolate|cotton candy|semen/.test(text))) return false;
        return true;
      });
      function score(product) {
        const relatedBonus=related.has(product.id)?-8:0;
        if(gap>0 && !state.discounted) {
          // Favor modest products that actually close a near-threshold gap, then sales rank/relevance.
          const closes=product.price>=gap;
          const replacesShippingFee=closes && product.price<=2000;
          const modestStep=closes && product.price-gap<=1000;
          return (replacesShippingFee?0:modestStep?500:1000) + product.rank*4 + relatedBonus + (closes?(product.price-gap)/100:product.price/200);
        }
        return product.rank*4 + relatedBonus + product.price/300;
      }
      candidates.sort((a,b)=>score(a)-score(b) || a.price-b.price || a.id-b.id);
      const product=candidates[0];
      if(product) selected.add(product.id);
      return product;
    }).filter(Boolean);
  }
  function element(tag,className,text) {
    const node=document.createElement(tag);
    if(className) node.className=className;
    if(text!==undefined) node.textContent=text;
    return node;
  }
  function productCard(product,state) {
    const card=element('article','ca-cart-addons__product');
    card.dataset.caAddonProduct=String(product.id);
    const imageLink=element('a','ca-cart-addons__image');
    imageLink.href=product.url;
    imageLink.setAttribute('aria-label',product.title);
    if(product.image) {
      const image=element('img');image.src=product.image;image.alt='';image.width=60;image.height=76;image.loading='lazy';image.decoding='async';imageLink.append(image);
    }
    const copy=element('div','ca-cart-addons__copy');
    const label=element('div','ca-cart-addons__category',product.label);
    const title=element('a','ca-cart-addons__name',product.title);title.href=product.url;
    copy.append(label,title);
    const gap=Math.max(0,state.threshold-state.eligibleSubtotal);
    if(state.currency==='CAD' && gap>0) {
      let text='Adds toward free Canadian shipping';
      if(!state.discounted) text=product.price>=gap ? 'Can unlock free Canadian shipping' : 'Leaves '+money(gap-product.price,state.currency)+' to free shipping';
      const effect=element('div','ca-cart-addons__effect',text);
      effect.classList.toggle('is-unlock',!state.discounted && product.price>=gap);
      copy.append(effect);
    }
    const action=element('div','ca-cart-addons__action');
    action.append(element('span','ca-cart-addons__price',money(product.price,state.currency)));
    if(product.variantCount===1) {
      const button=element('button','ca-cart-addons__add','+ Add');button.type='button';button.dataset.caAddonVariant=String(product.variantId);button.dataset.caAddonTitle=product.title;button.setAttribute('aria-label','Add '+product.title);button.disabled=mutationPending;action.append(button);
    } else {
      const link=element('a','ca-cart-addons__add','Choose options');link.href=product.url;action.append(link);
    }
    card.append(imageLink,copy,action);
    return card;
  }
  function announce(root,message) {
    const status=root.querySelector('[data-ca-addon-status]');
    status.textContent=message;status.hidden=!message;
  }
  async function hydrate(root,version) {
    let state;
    try {state=JSON.parse(root.querySelector('[data-ca-addon-state]').textContent);} catch {return;}
    if(!state.items.length) return;
    try {
      const [results,related]=await Promise.all([Promise.allSettled(categories.map(category=>getPool(category,state.currency,state.country))),getRelated(state)]);
      if(!root.isConnected || version!==generation) return;
      const pools=results.map(result=>result.status==='fulfilled'?result.value:[]);
      const products=chooseProducts(pools,state,related);
      const target=root.querySelector('[data-ca-addon-products]');
      target.replaceChildren(...products.map(product=>productCard(product,state)));
      root.querySelector('[data-ca-addon-fallback]').hidden=products.length>0;
      if(lastAnnouncement) announce(root,lastAnnouncement);
    } catch { /* The visible category links remain usable if recommendations are unavailable. */ }
  }
  function init() {
    const version=++generation;
    document.querySelectorAll('[data-ca-cart-addons]').forEach(root=>hydrate(root,version));
  }
  document.addEventListener('click',async event=>{
    const button=event.target.closest('button[data-ca-addon-variant]');
    if(!button || mutationPending) return;
    const root=button.closest('[data-ca-cart-addons]');
    if(!root || document.querySelector('#cart.loading,#offcanvas-cart.loading')) return;
    mutationPending=true;lastAnnouncement='';
    document.querySelectorAll('button[data-ca-addon-variant]').forEach(node=>{node.disabled=true;});
    button.textContent='Adding…';announce(root,'');
    let confirmedAdded=false;
    let rejected=false;
    try {
      const response=await fetch(route('cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.caAddonVariant),quantity:1}]})});
      if(!response.ok) {
        rejected=true;
        const data=await response.json();
        throw new Error(data.description || data.message || 'This item could not be added. Please choose another.');
      }
      confirmedAdded=true;
      lastAnnouncement='Added '+button.dataset.caAddonTitle+' to your cart.';
      if(typeof window.refreshCartContents==='function') {
        await window.refreshCartContents(response);
      } else {
        window.location.assign(route('cart'));return;
      }
    } catch(error) {
      if(confirmedAdded) {
        announce(root,'Your item was added. Open your cart to see the updated total.');
        button.textContent='Added';
        const link=element('a','ca-cart-addons__add','View cart');link.href=route('cart');button.replaceWith(link);
      } else if(rejected) {
        announce(root,error.message);button.textContent='+ Add';
        poolCache.clear();
      } else {
        announce(root,'We could not confirm the update. Open your cart before trying again.');
        const link=element('a','ca-cart-addons__add','View cart');link.href=route('cart');button.replaceWith(link);
      }
    } finally {
      mutationPending=false;
      document.querySelectorAll('button[data-ca-addon-variant]').forEach(node=>{node.disabled=false;});
    }
  });
  window.addEventListener('updated.ecomify.cart',()=>{if(!mutationPending) lastAnnouncement='';init();});
  window.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
